import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionAccountingPage_AccountingInfo_Init_Mutation = graphql(`
  mutation MissionAccountingPage_AccountingInfo_Init(
    $missionId: Id!
    $accountingInfo: AccountingInfoInput!
    $versionData: VersionDataInput
  ) {
    initAccountingInfo(
      missionId: $missionId
      accountingInfo: $accountingInfo
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type AccountingInfoInput = VariablesOf<
  typeof MissionAccountingPage_AccountingInfo_Init_Mutation
>['accountingInfo'];

export type AccountingInfo_Init_Result = ResultOf<
  typeof MissionAccountingPage_AccountingInfo_Init_Mutation
>;

export const useInitAccountingInfoMutation = () =>
  useGraphQLMutation(MissionAccountingPage_AccountingInfo_Init_Mutation);
